import { useEffect, useState } from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Activity, Brain, Sparkles, TrendingUp } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

const steps = [
  {
    icon: Brain,
    message: "Analisando dados do aluno...",
    color: "text-pink-500",
  },
  {
    icon: Activity,
    message: "Considerando condições de saúde...",
    color: "text-rose-500",
  },
  {
    icon: Sparkles,
    message: "Selecionando exercícios adequados...",
    color: "text-purple-500",
  },
  {
    icon: TrendingUp,
    message: "Montando progressão de aulas...",
    color: "text-pink-500",
  },
  {
    icon: Activity,
    message: "Finalizando plano personalizado...",
    color: "text-rose-500",
  },
];

export default function AIGenerationLoader() {
  const [currentStep, setCurrentStep] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentStep((prev) => (prev + 1) % steps.length);
    }, 2000);

    return () => clearInterval(interval);
  }, []);

  return (
    <Card className="border-pink-200 dark:border-pink-800 bg-gradient-to-br from-pink-50 to-rose-50 dark:from-pink-950/20 dark:to-rose-950/20">
      <CardContent className="py-12">
        <div className="flex flex-col items-center justify-center space-y-6">
          {/* Ícone animado */}
          <div className="relative">
            <motion.div
              animate={{
                scale: [1, 1.2, 1],
                rotate: [0, 180, 360],
              }}
              transition={{
                duration: 3,
                repeat: Infinity,
                ease: "easeInOut",
              }}
              className="relative"
            >
              <div className="w-20 h-20 bg-gradient-to-br from-pink-400 to-rose-500 rounded-full flex items-center justify-center shadow-lg">
                <Activity className="h-10 w-10 text-white" />
              </div>
            </motion.div>

            {/* Círculos pulsantes */}
            <motion.div
              animate={{
                scale: [1, 1.5, 1],
                opacity: [0.5, 0, 0.5],
              }}
              transition={{
                duration: 2,
                repeat: Infinity,
                ease: "easeInOut",
              }}
              className="absolute inset-0 w-20 h-20 bg-pink-300 dark:bg-pink-700 rounded-full -z-10"
            />
            <motion.div
              animate={{
                scale: [1, 2, 1],
                opacity: [0.3, 0, 0.3],
              }}
              transition={{
                duration: 2,
                repeat: Infinity,
                ease: "easeInOut",
                delay: 0.5,
              }}
              className="absolute inset-0 w-20 h-20 bg-rose-300 dark:bg-rose-700 rounded-full -z-10"
            />
          </div>

          {/* Mensagens */}
          <div className="h-16 flex items-center justify-center">
            <AnimatePresence mode="wait">
              {steps.map(
                (step, idx) =>
                  idx === currentStep && (
                    <motion.div
                      key={idx}
                      initial={{ opacity: 0, y: 10 }}
                      animate={{ opacity: 1, y: 0 }}
                      exit={{ opacity: 0, y: -10 }}
                      transition={{ duration: 0.5 }}
                      className="flex items-center gap-3"
                    >
                      <step.icon className={`h-5 w-5 ${step.color}`} />
                      <p className="text-lg font-medium">{step.message}</p>
                    </motion.div>
                  )
              )}
            </AnimatePresence>
          </div>

          {/* Progress dots */}
          <div className="flex gap-2">
            {steps.map((_, idx) => (
              <motion.div
                key={idx}
                animate={{
                  scale: idx === currentStep ? 1.2 : 1,
                  backgroundColor:
                    idx === currentStep
                      ? "hsl(var(--pink-500))"
                      : "hsl(var(--muted))",
                }}
                className="w-2 h-2 rounded-full"
              />
            ))}
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
